if (!customElements.get("model-popup")) {
  customElements.define(
    "model-popup",
    class ModelPopuop extends HTMLElement {
        constructor() {
            super();  
        }
        init() {
            this.trigger = this.querySelector("[data-trigger]");
            this.popup = document.querySelector(`${this.trigger.dataset.trigger}`);
            this.close = this.popup.querySelector("[data-close]");
            this.listen();
        }
        listen() {
            this.trigger.addEventListener("click",this.onTrigger.bind(this));
            this.close.addEventListener("click",this.onClose.bind(this));
            this.popup.addEventListener("click",this.onClose.bind(this));
            this.popup.querySelector(`.model-popup-content`).addEventListener("click",(e)=>{
                e.stopPropagation();
            })
        }
        onTrigger() {
            this.popup.classList.add("active")
        }
        onClose() {
            if(this.popup.classList.contains("active")){
                this.popup.classList.remove("active");
            }

        }
         connectedCallback() {
            this.init();
        }
    }
  );
}
